module.exports = __webpack_public_path__ + "static/media/bell-agogo1.dec8487e.aac";